module.exports = __webpack_public_path__ + "public/img/logo黑2.d0272920.png";